import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import {prefetchStaticPage} from '@common/static-pages/use-static-page';
import {RouteObject} from 'react-router';

export const commonRoutes: RouteObject[] = [
  {
    path: 'contact',
    loader: () => prefetchStaticPage('contact'),
    lazy: () => import('@common/contact/contact-us-page'),
  },
  {
    path: 'developers',
    loader: () => prefetchStaticPage('developers'),
    lazy: () => import('@common/developers/developers-page'),
  },
  {
    path: 'api-docs',
    loader: () => prefetchStaticPage('api_docs'),
    lazy: () => import('@common/developers/api-docs-page'),
  },
  {
    path: 'pages/:pageSlug',
    lazy: () => import('@common/custom-page/custom-page-layout'),
  },
  {
    path: 'pages/:pageId/:pageSlug',
    lazy: () => import('@common/custom-page/custom-page-layout'),
  },
  {
    // Admin opened an admin page while using "View as" (see authGuard).
    path: 'viewing-as/admin-closed',
    lazy: () => import('@common/auth/viewing-as-admin-closed-page'),
  },
  {
    path: '404',
    element: <NotFoundPage />,
  },
];
